function CartReload(data) {
    let container = document.getElementById('cart-table')
    let c = document.querySelector('.cart-table');
    let tB = document.getElementById('total-bottom');
    let cartTitle = document.querySelector('#cart > .banner-section');
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(data, 'text/html');
    let nC = htmlDocument.documentElement.querySelector('.cart-table');
    let nTB = htmlDocument.documentElement.querySelector('#total-bottom');
    let nCartTitle = htmlDocument.querySelector('#cart > .banner-section');
    let nSave = htmlDocument.documentElement.querySelector(".total_discount-text span");
    c.replaceWith(nC);
    tB.replaceWith(nTB);
    if (nSave.innerHTML == "$0.00") {
        document.querySelector(".total_discount-text").style.display = "none";
    }
    cartTitle.replaceWith(nCartTitle);
    container.querySelector('.full-form').classList.remove('hidden');
    container.querySelector('.empty-form').classList.add('hidden');
    Quantity(container);
    CartButtons();
}

function CartChange(q, container) {
    let header = document.querySelector('header');
    let it = q.closest('.item');
    let id = it.getAttribute('data-product-id');
    let qty = it.querySelector('.item-qty').value;
    let rct = container.getAttribute('data-recent');
    let aB = document.getElementById('ajaxBusy');
    let cTa = document.getElementById('cart-table');
    let cC = document.querySelectorAll('.cartCountSelector');
    let tB = document.getElementById('total-cart-bottom');
    let aS = document.querySelector('.animate-section');
    let cD = document.getElementById('cart-dropdown');
    if (q != '') {
        aB.style.display = 'block';
    }
    fetch(theme.routes_cart_change_url + '.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ 'quantity': qty, 'id': id })
    }).then(function (r) {
        return r.json();
    }).then(function (j) {
        if (q != '') {
            cC.forEach(function (c) {
                c.textContent = j.item_count;
            });
            tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        }
        if (j.item_count == 0) {
            cTa.querySelector('.full-form').classList.add('hidden');
            cTa.querySelector('.empty-form').classList.remove('hidden');
            aB.style.display = 'none';
            if (theme.dropdown == true) {
                document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
                document.querySelector('.cart-count-mobile').classList.remove('void');
            }
            if (cD) {
                cD.remove();
            }
            if (rct == 'true' && aS) {
                document.querySelector('.animate-section').classList.add('go', 'up');
            };
        } else {
            let x = theme.cart;
            CartDrop(x);
            fetch(theme.routes_cart_url)
                .then(response => response.text())
                .then(data => {
                    if (qty != '') {
                        if (qty == 0) {
                            it.remove();
                        }
                        CartReload(data)
                        aB.style.display = 'none';
                    }
                    imageObserver();
                }).catch(function (err) {
                    console.error('!: ' + err)
                });
        };
    }).catch(function (err) {
        console.error('!: ' + err)
    });
}

function CartButtons() {
    let container = document.getElementById('cart-table'),
        qB = container.querySelectorAll('.qtybtn');
    qB.forEach(function (q) {
        if (q.classList.contains('icon-plus')) {
            let qF = q.closest('.quantity.form'),
                vV = qF.querySelector('.item-qty').value,
                vM = qF.querySelector('.item-qty').getAttribute('max');
        };
        setTimeout(function () {
            q.onclick = function (ev) {
                if (vM && vM == vV) {
                    return;
                }
                CartChange(q, container);
            }
        }, 1);
    })
    let qI = container.querySelectorAll('.item-qty');
    qI.forEach(function (q) {
        let timeout;
        let vV = q.value,
            vM = q.getAttribute('max');
        q.addEventListener('keyup', function (e) {
            if (e.key == 'Tab' || e.key == 'Shift') return;
            let nV = q.value;
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                if (vM && nV == vV && vM == nV) {
                    return;
                }
                CartChange(q, container);
            }, 750);
        });
    });
}

theme.CartPage = (function () {
    function CartPage(container) {
        let sectionId = container.getAttribute('data-section-id');
        let chk = container.getAttribute('data-check');
        let rct = container.getAttribute('data-recent');
        let rV = document.getElementById('recently-viewed');
        let rVP = document.getElementById('recently-viewed-placeholder');
        theme.cart = true;
        Quantity(container);
        if (chk == 'true') {
            let nC = container.querySelector('[name="checkout"]');
            document.getElementById('cart-terms').onclick = function (ev) {
                if (this.checked == true) {
                    nC.classList.remove('outline');
                    nC.removeAttribute('disabled');
                    nC.setAttribute('aria-label', theme.language.cart_general_checkout);
                    nC.value = theme.language.cart_general_checkout;
                    nC.textContent = theme.language.cart_general_checkout;
                } else {
                    nC.classList.add('outline');
                    nC.setAttribute('disabled', true);
                    nC.setAttribute('aria-label', theme.language.cart_general_agree);
                    nC.value = theme.language.cart_general_agree;
                    nC.textContent = theme.language.cart_general_agree;
                }
            };
        };
        CartButtons(container);
        if (rct == 'true') {
            function gPD() {
                const pD = JSON.parse(localStorage.getItem('rVP'));
                const rVH = []
                if (pD) {
                    rV.classList.remove('hidden');
                    pD.forEach(function (item, i) {
                        rVH.push('id:' + item.pID);
                    });
                    const rB = rVH.join('%20OR%20');
                    fetch(theme.routes_search_url + '?&type=product&q=' + rB)
                        .then(response => response.text())
                        .then(data => {
                            const parser = new DOMParser();
                            const htmlDocument = parser.parseFromString(data, 'text/html');
                            let rVD = document.querySelector('.recently-viewed');
                            let cP = htmlDocument.documentElement.querySelector('.collection-products');
                            rVP.remove();
                            rVD.appendChild(cP);
                            imageObserver();
                            if (theme.settings.quickView) {
                                Quick();
                            };
                            if (theme.settings.compare) {
                                CompareProducts();
                            };
                            Swatches(container);
                            if (theme.settings.cart) {
                                let sI = htmlDocument.documentElement.querySelector('.search_page').getAttribute('data-section-id');
                                Cart(container, sI);
                            }
                        }).catch(function (err) {
                            console.log('!: ' + err);
                        });
                }
            }
            gPD();
        };
        if (Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
        }
    }
    return CartPage;
})();